import { PaginatedDtoSchema } from "@core/data/dto/paginated.dto.ts";
import { ReportStationSummaryDtoSchema } from "@report/data/dto/report-station.dto.ts";
import * as z from "zod";

const ReportDailyActivityRowDtoSchema = z
    .object({
        moving_time: z.number(),
        stopped_time: z.number(),
        traveled_kilometers: z.number(),
        worked_time: z.number(),
    })
    .readonly();

const ReportStationDailyActivityDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.object({
            totals: ReportDailyActivityRowDtoSchema,
            rows: z
                .record(z.string(), ReportDailyActivityRowDtoSchema)
                .optional(),
        }),
        station: ReportStationSummaryDtoSchema,
        pagination: PaginatedDtoSchema,
    })
    .readonly();

export const ReportDailyActivityDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.record(z.string(), ReportStationDailyActivityDtoSchema),
    })
    .readonly();

export type ReportDailyActivityDto = z.output<
    typeof ReportDailyActivityDtoSchema
>;
